import { useState, useLayoutEffect } from 'react';
var QueryParamsMap = /*#__PURE__*/function (QueryParamsMap) {
  QueryParamsMap["maxWidth"] = "max-width";
  QueryParamsMap["minWidth"] = "min-width";
  QueryParamsMap["maxHeight"] = "max-height";
  QueryParamsMap["minHeight"] = "min-height";
  return QueryParamsMap;
}(QueryParamsMap || {});
function useMediaQueryBase(query, matchMedia) {
  const [match, setMatch] = useState(() => {
    if (matchMedia !== null) {
      return matchMedia(query).matches;
    }
    return false;
  });
  useLayoutEffect(() => {
    let active = true;
    if (matchMedia === null) {
      return;
    }
    const queryList = matchMedia(query);
    const updateMatch = () => {
      // Workaround Safari wrong implementation of matchMedia
      // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };
    updateMatch();
    queryList.addListener(updateMatch);

    // eslint-disable-next-line consistent-return
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia]);
  return match;
}
export default function useMediaQuery(queryInput) {
  // Wait for jsdom to support the match media feature.
  // Most of the time, the match media logic isn't central to people tests.
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
  const query = parseQuery(queryInput);
  const matchMedia = supportMatchMedia ? window.matchMedia : null;
  const match = useMediaQueryBase(query, matchMedia);
  return match;
}
function parseQuery(query) {
  if (typeof query === 'string') {
    return query.replace(/^@media( ?)/m, '');
  }
  let parsed = '(';
  Object.keys(query).forEach(key => {
    parsed += `${QueryParamsMap[key]}: ${query[key]}px, `;
  });
  parsed = parsed.slice(0, -2); // remove trailing ', '
  parsed += ')';
  return parsed;
}